import React, { useCallback, useState } from 'react';
import { Input, Label } from 'reactstrap';

const CommonDropdown = ({ label, onChange, disabled = false, dropdownList = [], value, valueField, labelField }) => {

    const [disable, setDisable] = useState(false)
    const handleDisable = useCallback((val) => {
        setDisable(val)
    })

    return (
        <>
            {label && <Label for="type">{label}</Label>}
            <Input type="select"
                onChange={e => {
                    onChange(e.target.value)
                    handleDisable(true)
                }}
                disabled={disabled} style={{ textTransform: "capitalize" }}>
                {dropdownList?.map((el, index) => {
                    return (
                        <>
                            {index === 0 && <option
                                disabled={disable}
                                value={'selectValue'}
                                selected={'selectedValue' === value}
                            > Select Option
                            </option>}
                            <option
                                key={valueField ? el[valueField] : el.name}
                                value={valueField ? el[valueField] : el.name}
                                selected={(valueField ? el[valueField] : el?.name) === value}
                            >
                                {labelField && el[labelField] || el?.title || el?.name}
                            </option>
                        </>
                    );
                })}
            </Input>
        </>
    );
};
export default CommonDropdown;
